import React, { useEffect } from "react";
import { Grid, Icon } from "semantic-ui-react";
// import Tc_ReturningVehicle from "../../../CBSA_App/components/entrySummaryForms/pga/TC/Tc_ReturningVehicle";
import Input from "../Form/Input/index";
import Button from "../button/Button"
// import { updateData } from "../../../actions/searchContextActions";
import DeleteConfirmation from "./deleteComfirmationModal";
import { DropDown }  from "../../../../CBSA_App/components/formComponents/dropDown"
import { useSelector, useDispatch } from "react-redux"
import { initiate_main_form, update_main_form } from "../../../../actions/manageProductHistory"
import { displayMasterItem } from "../../../../CBSA_App/components/entrySummaryForms/util/index";
import { getValidationError } from "../../../../util";
import { cloneDeep } from "lodash";


const UpdateFormCA = ({ data, updateAPI, deleteAPI, selectedRowMethod, formReset }) => {
    console.log("update component:", data)
    const [isOpen, setIsOpen] = React.useState(true);
    const [dropDownVal, setDropDownVal] = React.useState({});
    const [formOpen, setFormOpen] = React.useState(true);
    const [delConfirm, setdelConfirm] = React.useState(false);
    const hsuomDropDown = JSON.parse(sessionStorage.getItem("DROPDOWN_VAL_CBSA")).eventMessage.hsUOM
    const tariffTreatmentDropdown = JSON.parse(sessionStorage.getItem("DROPDOWN_VAL_CBSA")).eventMessage.tariffTreatment
    const countryDropDown = JSON.parse(sessionStorage.getItem("DROPDOWN_VAL_CBSA")).eventMessage.countryOfOrigin
    const gstRateDropDownValues = JSON.parse(sessionStorage.getItem("DROPDOWN_VAL_CBSA")).eventMessage.gstCodes
    const unitOfMeasurementDropdownValues = JSON.parse(sessionStorage.getItem("DROPDOWN_VAL_CBSA")).eventMessage.merchandiseUOM
    const prodHistData = useSelector(state => state.productHistRow);
    const [isSaving, setIsSaving] = React.useState(false);
    console.log("prodHistData:", prodHistData)
    const errorJSON = {"description": {"stateVar": "prodHistData.lineItemJsonCA.description",  "error": ""}, "classificationNo": {"stateVar": "prodHistData.lineItemJsonCA.classificationNo",  "error": ""},
    "countryOfOrigin": {"stateVar": "prodHistData.lineItemJsonCA.countryOfOrigin",  "error": ""}, "rateOfGst": {"stateVar": "prodHistData.lineItemJsonCA.rateOfGst",  "error": ""},
    "tariffCode": {"stateVar": "prodHistData.lineItemJsonCA.tariffCode",  "error": ""}, "tariffTreatment": {"stateVar": "prodHistData.lineItemJsonCA.tariffTreatment",  "error": ""},
    "vfdCode": {"stateVar": "prodHistData.lineItemJsonCA.vfdCode", "error": ""}}
    console.log("error Json", errorJSON)
    const [errorState, setErrorState] = React.useState(errorJSON)
    const dispatch = useDispatch()
    console.log("errorState: ", errorState)
    const onChange = (field, value, lineItemJsonCA) => {
        dispatch(update_main_form(field, value, undefined, undefined, "CA", lineItemJsonCA))
    }
    const toggleExpandForm = () => {
        if(isOpen)
        {
            setIsOpen(false);
        }
        else{
            setIsOpen(true);
        }
    }

    const toggleFormOn = () => {
        if(formOpen)
        {
            setFormOpen(false);
        }
        else
        {
            setFormOpen(true);
        }
    }

    const reset = () => {
        formReset(prodHistData.productLineId, prodHistData.customerId)   
    }

    const fromValidation = () => {
        let flag = 0
        for(let key1 in errorJSON)
        {
            let err = getValidationError(
                key1,
                eval(errorJSON[key1].stateVar),
                "Merchandise",
                "CA"
            )
            if(err[0])
                flag=1;
            if(key1 === "manufacturerName" && err[0])
                errorJSON[key1].error = "Manufacturer Name is manadatory";
            else if(key1 === "description" && err[0])
            errorJSON[key1].error = "Product Description Name is manadatory";
            else
                errorJSON[key1].error = err[0];
        }
        setErrorState(errorJSON);
        if(!flag)
        {
            return true;
            // setIsOpen(false)
        }
        return false;
    }

    return ( 
        <div>
            { formOpen && prodHistData.lineItemJsonCA && <div className="update-from-container">
                <div>
                    <div className="stepNumber" onClick={() => toggleExpandForm()}>
                        <Icon 
                        name={isOpen ? `minus circle`: `plus circle`}  >
                        
                        </Icon>
                        <span>Update Form</span>
                    </div>
                    <div className="update-close-icon" style={{ float:"right" }}>
                        <Icon  name="close" size="large" onClick={() => {
                                toggleFormOn()
                                selectedRowMethod("-2")
                            }} />
                    </div>
                    <div className="update-trash-icon" style={{ float:"right" }}>
                        {/* <Icon  name="trash alternate" size="large" onClick={() => {
                            setdelConfirm(true);
                        }} /> */}
                        <DeleteConfirmation message={<p>Are you sure you want to delete the item with Product Description: <b>{prodHistData.productDescription}</b></p>} icon={"trash alternate"} delAPI={deleteAPI} toggleFormOn={toggleFormOn} productLineId={prodHistData.productLineId} />
                    </div>
                    
                </div>
                { isOpen && <Grid className="kn_form">
                    <br />
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={8}>
                            <Input name={"description"}  showErrorInPopup={true} hasError={errorState.description.error ? {message: errorState.description.error } : ""} label="Product Description" 
                            topLabelClassNames="top-element"
                            value={prodHistData.lineItemJsonCA.description ? prodHistData.lineItemJsonCA.description : ""} 
                            onChange={(field, value) => { onChange(field, value, true) }}
                            onBlur={() => {
                                fromValidation();
                            }}  ></Input>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={3}>
                            <Input name={"classificationNo"} showErrorInPopup={true} hasError={errorState.classificationNo.error ? {message: errorState.classificationNo.error } : ""} topElement={true} rowElement={true}  label="HTS" 
                            topLabelClassNames="top-element"
                            value={prodHistData.lineItemJsonCA.classificationNo ? prodHistData.lineItemJsonCA.classificationNo : ""} 
                            onChange={(field, value) => { onChange(field, value, true) }}
                            onBlur={() => {
                                fromValidation();
                            }}  ></Input>
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={5}>
                            <Input name={"sku"} label="SKU/Product Tag" topElement={true} rightElement={true} 
                            topLabelClassNames="top-element last-element-row"
                            value={prodHistData.lineItemJsonCA.sku ? prodHistData.lineItemJsonCA.sku : ""} 
                            onChange={(field, value) => { onChange(field, value, true) }}
                            onBlur={() => {
                                fromValidation();
                            }} ></Input>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={5}>
                            <DropDown
                                isLabel={false}
                                name="countryOfOrigin"
                                type="text"
                                label={"COuntry Of Origin"}
                                labelClassName="labelEl-dropdown"
                                labelTitle="HS UNIT OF MESSUREMENT"
                                className={"dropdown-element history dropdown100 cbsa-hs-unit-of-measurement"}
                                text={displayMasterItem(prodHistData.lineItemJsonCA.countryOfOrigin ? prodHistData.lineItemJsonCA.countryOfOrigin : "_BLANK_", countryDropDown)}
                                data={ countryDropDown }
                                onChange={(value) => {
                                    let val = value;
                                    onChange("countryOfOrigin", val, true);
                                }}
                                onBlur={() => {
                                    fromValidation();
                                }}
                                showErrorInPopup={true}
                                hasError={errorState.countryOfOrigin.error ? {message: errorState.countryOfOrigin.error } : ""}
                                // {...FIELD_META}
                            />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={7}>
                            <DropDown
                                isLabel={false}
                                name="tariffTreatment"
                                type="text"
                                label={"Tariff Treatement"}
                                labelClassName="labelEl-dropdown"
                                labelTitle="HS UNIT OF MESSUREMENT"
                                className={"dropdown-element history dropdown100 cbsa-hs-unit-of-measurement"}
                                text={displayMasterItem(prodHistData.lineItemJsonCA.tariffTreatment ? prodHistData.lineItemJsonCA.tariffTreatment : "PLEASE_CHOOSE_TARIFF", tariffTreatmentDropdown)}
                                data={ tariffTreatmentDropdown }
                                onChange={(value) => {
                                    let val = value;
                                    onChange("tariffTreatment", val, true);
                                }}
                                onBlur={() => {
                                    fromValidation();
                                }}
                                // {...FIELD_META}
                            />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={4}>
                            <Input name={"tariffCode"} showErrorInPopup={true} hasError={errorState.tariffCode.error ? {message: errorState.tariffCode.error } : ""} label="Tariff Code" rightElement={true} 
                            topLabelClassNames="top-element last-element-row"
                            value={prodHistData.lineItemJsonCA.tariffCode ? prodHistData.lineItemJsonCA.tariffCode : ""} 
                            onChange={(field, value) => { onChange(field, value, true) }}
                            onBlur={() => {
                                fromValidation();
                            }}  ></Input>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={11}>
                            <DropDown
                                isLabel={false}
                                name="rateOfGst"
                                type="text"
                                label={"GST RATE"}
                                labelClassName="labelEl-dropdown"
                                labelTitle="HS UNIT OF MESSUREMENT"
                                className={"dropdown-element history dropdown100 cbsa-hs-unit-of-measurement"}
                                text={displayMasterItem(prodHistData.lineItemJsonCA.rateOfGst ? prodHistData.lineItemJsonCA.rateOfGst : "Standard GST Rate", gstRateDropDownValues)}
                                data={ gstRateDropDownValues }
                                onChange={(value) => {
                                    let val = value;
                                    onChange("rateOfGst", val, true);
                                }}
                                onBlur={() => {
                                    fromValidation();
                                }}
                                showErrorInPopup={true}
                                hasError={errorState.countryOfOrigin.error ? {message: errorState.countryOfOrigin.error } : ""}
                                // {...FIELD_META}
                            />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={3}>
                            <DropDown
                                isLabel={false}
                                type="text"
                                label={"Unit of Measurement"}
                                labelClassName="labelEl-dropdown"
                                labelTitle="HS UNIT OF MESSUREMENT"
                                className={"dropdown-element history dropdown100 cbsa-hs-unit-of-measurement"}
                                text={displayMasterItem(prodHistData.lineItemJsonCA.unitOfMeasurement ? prodHistData.lineItemJsonCA.unitOfMeasurement : "PLEASE_CHOOSE_UOM", unitOfMeasurementDropdownValues)}
                                data={ unitOfMeasurementDropdownValues }
                                onChange={(value) => {
                                    let val = value;
                                    onChange("unitOfMeasurement", val, true);
                                }}
                                onBlur={() => {
                                    fromValidation();
                                }}
                                showErrorInPopup={true}
                                hasError={errorState.countryOfOrigin.error ? {message: errorState.countryOfOrigin.error } : ""}
                                // {...FIELD_META}
                            />
                        </Grid.Column>
                        <Grid.Column mobile={16} tablet={8} computer={2}>
                            <Input name={"vfdCode"} showErrorInPopup={true} hasError={errorState.vfdCode.error ? {message: errorState.vfdCode.error } : ""} label="VFD Code" rowElement={true} 
                            topLabelClassNames="top-element last-element-row"
                            value={prodHistData.lineItemJsonCA.vfdCode ? prodHistData.lineItemJsonCA.vfdCode : ""} 
                            onChange={(field, value) => { onChange(field, value, true) }}
                            onBlur={() => {
                                fromValidation();
                            }}  ></Input>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column mobile={16} tablet={8} computer={16}>
                            <Input name={"manufacturerName"} showErrorInPopup={true} label="Manufacturer Name" bottomElement={true} leftElement={true} 
                            topLabelClassNames="top-element last-element-col last-element-row"
                            value={prodHistData.lineItemJsonCA.manufacturerName ? prodHistData.lineItemJsonCA.manufacturerName : ""}
                            onChange={(field, value) => { onChange(field, value, true) }}
                            onBlur={() => {
                                fromValidation();
                            }}  ></Input>
                        
                        </Grid.Column>
                    </Grid.Row>
                    
                    <Button className="newButton primaryBtn btnType1 mediumBtn" 
                        id="saveFormProductHistory" onClick={() => {
                        if(fromValidation()) {
                            setIsSaving(true);
                            updateAPI(prodHistData);
                            setTimeout(() => setIsSaving(false), 2000);
                        }
                    }}>{isSaving ? "Saving..." : "Save"}</Button>
                    <Button className="newButton secondaryBtn btnType1 mediumBtn"
                        id="updateFormProductHistory" onClick={() => {
                        reset()
                    }}>Reset</Button>
                </Grid> }
            </div> }
        </div>
     );
}
 
export default UpdateFormCA;